import React from 'react'
import './Chip.scss'
import { CssLayoutProperties } from '../utils/CssLayoutProperties'
import classNames from 'classnames'

interface ChipProps {
  outline?: boolean
  children: React.ReactNode
  style?: CssLayoutProperties
}

export const Chip: React.FC<ChipProps> = (props) => {
  const { outline, children, style } = props

  return (
    <div className={classNames('Chip', { 'Outline': outline })} style={style}>
      {children}
    </div>
  )
}